import {Response} from "@/hooks/services/queries/types";
import logger from "@FRAMEWORK/utils/logger";
import useConfigureAxios from "@FRAMEWORK/utils/useConfigureAxios";
import {UseQueryOptions, useQuery} from "@tanstack/react-query";

type GlobalGoodsFlag = {
	[key: string]: {
		[goodsCd: string]: string;
	}[];
};

/** ```
 * 공통 텍스트 배너조회 API
 *   `/global/goodsFlag`
 * parameter
 *      types: string (ex)"live,pang" 여러 타입 조회시 콤마(,)로 구분)
 * ```*/
const key = "useGlobalGoodsFlag";
const getPath = (): string | null => `/bff/global/goodsFlag`;

/** ```
 * 공통 텍스트 배너조회 API
 *   `/global/goodsFlag`
 * parameter
 *      type: string (ex)"PKG,HOTEL,AIR,TOUR" 여러 타입 조회시 콤마(,)로 구분)
 * ```*/
const useGlobalGoodsFlag = (type = "PKG", options?: Partial<UseQueryOptions<Response<GlobalGoodsFlag>, Error>>) => {
	try {
		return useQuery({
			queryKey: [key, type, getPath()],
			queryFn: () => useConfigureAxios.get(getPath(), {params: {type}}).then(r => r.data),
			gcTime: Infinity,
			staleTime: Infinity,
			throwOnError: true,
			...options,
		});
	} catch (error) {
		logger.error(error);
	}
};
export default useGlobalGoodsFlag;
export {getPath};
export type {GlobalGoodsFlag};
